export const getMobileEnv = () => {
  const u = navigator.userAgent;
  return {
    wechat: !!u.toLowerCase().match(/MicroMessenger/i), //微信终端
    wechatMobile:
      !!u.toLowerCase().match(/MicroMessenger/i) &&
      (u.indexOf("Android") > -1 ||
        u.indexOf("iPhone") > -1 ||
        u.indexOf("iPad") > -1), //微信终端
    wechatPc:
      !!u.toLowerCase().match(/MicroMessenger/i) &&
      !(
        !!u.toLowerCase().match(/MicroMessenger/i) &&
        (u.indexOf("Android") > -1 ||
          u.indexOf("iPhone") > -1 ||
          u.indexOf("iPad") > -1)
      ),
  };
};

const getWxParmas = () => {
  return new Promise((resolve) => {
    fetch("https://test.333f.com/data-center/wechat/sign", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        appid: "wxbc5b737d6921c2dd",
        localUrl: location.href,
      }),
    })
      .then((req) => {
        return req.json();
      })
      .then((data) => {
        resolve(data);
      });
  });
};

export const initConfig = () => {
  return new Promise((resolve, reject) => {
    getWxParmas()
      .then((res) => {
        const { appId, nonceStr, signature, timestamp } = res.data;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId, // 必填，公众号的唯一标识
          timestamp, // 必填，生成签名的时间戳
          nonceStr, // 必填，生成签名的随机串
          signature, // 必填，签名
          jsApiList: [], // 必填，需要使用的JS接口列表,
          openTagList: ["wx-open-launch-weapp"],
          fail(err) {
            console.log(err);
          },
        });
        window.wx.ready(function () {
          //   wxShare();
          resolve(true);
        });
      })
      .catch((err) => {
        console.log(err);
        reject();
      });
  });
};
